import React, {Component, Fragment} from "react";
import Header from "./Header";
import VotesByHour from "./VotesByHour";
import TurnoutTable from "./TurnoutTable";
import ResultsTable from "./ResultsTable";
import axios from "axios";
import Footer from "./Footer";
import RolloutSummary from "./RolloutSummary";
import RolloutSummaryW from "./RolloutSummaryW";
import TurnoutDropInTable from "./TurnoutDropInTable";
import {getMessage} from "./util";
import {adapterSnapshotData} from "./adapterSnapshotData";
import election_messages from "./electionMessages.json";

class Home extends Component {

    constructor(props) {
        super(props);
        this.state = {
            snapshot: null,
            election: null,
            loading: false,
            messages: null
        };
        this.election_id='wISyWFxW';
    }

    componentDidMount() {
        this.loadElection(this.election_id);
        this.loadSnapshot(this.election_id);
    }

    loadElection = election_id => {
        this.setState({loading: true}, async () => {

            const getElection = async () => {
                try {
                    return (await axios({
                        method: "get",
                        url: process.env.REACT_APP_BACKUP_URL +
                            "/" +
                            election_id +
                            "/header.json"
                    }));
                } catch (error) {

                    if (error.response && error.response.status === 404) {
                        try {
                            return (await axios({
                                method: "get",
                                url:
                                    process.env.REACT_APP_API_URL +
                                    "/election/" +
                                    election_id
                            }));
                        } catch (error) {
                            throw(error);
                        }

                    }
                }
            }


            const election = await getElection();

            // Los mensajes vivían en un template de S3 que la CSP del CloudFront bloquea.
            // Van embebidos en el bundle para no depender de un origen externo.
            this.setState({election: election.data, messages: election_messages, loading: false});
        })
    }


    loadSnapshot = election_id => {

        // Solo adaptamos el formato nuevo (arreglo); el CDN puede seguir dando el legacy.
        const toLegacySnapshot = data =>
            Array.isArray(data) ? adapterSnapshotData(data, election_id, null) : data;

        this.setState({loading: true}, () =>
            axios({
                method: "get",
                url:
                    process.env.REACT_APP_BACKUP_URL +
                    "/" +
                    election_id +
                    "/snapshot.json"
            })
                .then(response => {
                    this.setState({
                        loading: false,
                        snapshot: toLegacySnapshot(response.data)
                    });
                })
                .catch(error => {
                    if (error.response && error.response.status === 404) {
                        axios({
                            method: "get",
                            url:
                                process.env.REACT_APP_API_URL +
                                "/election/" +
                                election_id +
                                "/snapshot"
                        })
                            .then(response => {
                                this.setState({
                                    loading: false,
                                    snapshot: toLegacySnapshot(response.data)
                                });
                            })
                            .catch(error => {
                                this.setState({loading: false});
                            });
                    } else {
                        this.setState({loading: false});
                    }
                })
        );
    };

    render() {

        const thestyle = (this.state.election && this.state.election.configuration.templates.filter(t => t.name === "vote.css").length > 0) ? this.state.election.configuration.templates.filter(t => t.name === "vote.css")[0].content : process.env.PUBLIC_URL + "/vote.css";

        return (
            <div className="container-fluid">
                <link rel="stylesheet" type="text/css" href={thestyle}/>
                <div className="sticky-top  text-center  d-flex flex-row-reverse">
                    <div className="p-1 EvColor TopLogo rounded-bottom mr-4">
                        <img src="/logo-blanco.png" alt="logo"/>
                    </div>
                </div>
                {this.state.election != null && this.state.snapshot != null && (
                    <Fragment>


                        <Header election={this.state.election} messages={this.state.messages}/>
                        <ResultsTable districts={this.state.snapshot.districts}
                                      votantes={this.state.snapshot}
                                      election_id={this.election_id} messages={this.state.messages}/>
                        <br/><br/>
                        <section className="row justify-content-center">
                            <div className="col-12 col-sm-11 col-md-9 col-lg-7 text-center">
                                <h5>Total de votos recibidos: <strong>{this.state.snapshot.voters.electronic_voted}</strong></h5>
                            </div>

                        </section>
                        <React.Fragment>
                            <div className="row EvColorGris justify-content-center text-white p-3">
                                <div className="col-12 col-sm-11 col-md-9 col-lg-7">
                                    <h4>{getMessage('participation', this.state.messages)}</h4>
                                </div>
                            </div>
                            <br/>
                            <div className="row  justify-content-center mb-4">
                                <div className="col-12 col-sm-11 col-md-9 col-lg-7">
                                    <RolloutSummary election={this.state.election} snapshot={this.state.snapshot} messages={this.state.messages}/>
                                </div>
                            </div>
                            <div className="row EvColorGris justify-content-center text-white p-3">
                                <div className="col-12 col-sm-11 col-md-9 col-lg-7">
                                    <h4>{getMessage('weighted_participation', this.state.messages)}</h4>
                                </div>
                            </div>

                            <br/>
                            <div className="row  justify-content-center">
                                <div className="col-12 col-sm-11 col-md-9 col-lg-7">
                                    <RolloutSummaryW election={this.state.election} snapshot={this.state.snapshot} messages={this.state.messages}/>
                                </div>
                            </div>
                        </React.Fragment>
                    </Fragment>
                )}

                <br/><br/>
                <VotesByHour election_id={this.election_id} messages={this.state.messages}/>
                <br/><br/>

                {/* El snapshot resuelve antes que la elección; el guard sobre districts evita
                    que este bloque tumbe el render. */}
                {this.state.snapshot != null && this.state.snapshot.districts && Object.keys(this.state.snapshot.districts).length > 1 && (

                    <TurnoutTable snapshot={this.state.snapshot} messages={this.state.messages}/>
                )}

                {this.state.snapshot && this.state.snapshot.drop_in_places && (

                    <TurnoutDropInTable snapshot={this.state.snapshot} messages={this.state.messages}/>
                )}
                <br/><br/>
                <Footer election={this.state.election} messages={this.state.messages}/>
            </div>
        );
    }
}


export default Home;
